import React from "react";
import { Link } from "gatsby";
import starIcon from "../../assets/images/star-icon.png";
import danwei from "../../assets/images/home/intro-of-hro/danwei.png";
import yuangong from "../../assets/images/home/intro-of-hro/yuangong.png";
import hetong from "../../assets/images/home/intro-of-hro/hetong.png";
import shebao from "../../assets/images/home/intro-of-hro/shebao.png";
import gongzi from "../../assets/images/home/intro-of-hro/gongzi.png";
import feiyong from "../../assets/images/home/intro-of-hro/feiyong.png";
import serviceIcon7 from "../../assets/images/services/service-shape4.png";

const IntroOfHro = () => {
  const benefits = [
    {
      title: "单位管理",
      desc: "客户单位基本信息管理与单位合同协议",
      img: danwei,
    },
    {
      title: "人员管理",
      desc: "快速收集员工信息，管理人员合同归属",
      img: yuangong,
    },
    {
      title: "电子合同",
      desc: "在线发起劳动合同网签，合同自动存档",
      img: hetong,
    },
    {
      title: "社保公积金",
      desc: "生成人员增减，多地社保、公积金缴纳",
      img: shebao,
    },
    {
      title: "工资管理",
      desc: "支持多套薪酬结构，社保个税自动核算",
      img: gongzi,
    },
    {
      title: "费用结算",
      desc: "财务收款、开票与付款，生成结算单据",
      img: feiyong,
    },
  ];
  return (
    <section className="services-area ptb-70" id="IntroOfHro">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="project" /> HRO
          </span>
          <h2>HRO SaaS人力外包服务平台</h2>
          <p>
            一体化的人力外包与劳务派遣业务管理
            <br />
            实现单位管理、人员管理、合同管理、薪税核算、社保公积金、费用结算
            <br />
            帮助企业降本增效、提升服务质量与客户满意度
          </p>

          <Link to="/hro" className="default-btn">
            <i className="flaticon-right"></i>
            了解更多 <span></span>
          </Link>
        </div>

        <div className="row">
          {benefits.map((benefit, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="single-services-box-item">
                <div className="icon">
                  <img src={benefit.img} alt={benefit.title} width={50} height={50} />
                </div>
                <h5>{benefit.title}</h5>
                <p>{benefit.desc}</p>
                <div className="shape">
                  <img src={serviceIcon7} alt="services" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntroOfHro;
